import { resolveNextViteImage } from '@infl-ts/util-resolve-next-vite-image';
import AppleIcon from '@mui/icons-material/Apple';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import { Box } from '@mui/material';
import { absurd } from 'fp-ts/function';
import oauthIcon from './oauth.jpeg';
import { jsx as _jsx } from "react/jsx-runtime";

var ProviderIcon = function ProviderIcon(_ref) {
  var __typename = _ref.social.__typename;
  if (__typename === 'Facebook') return /*#__PURE__*/_jsx(FacebookIcon, {
    sx: function sx(t) {
      return {
        height: 48,
        width: 48,
        fill: t.palette.other.facebook
      };
    }
  });

  if (__typename === 'Twitter') {
    return /*#__PURE__*/_jsx(Box, {
      sx: {
        height: 36,
        width: 36,
        margin: 0.75,
        background: function background(t) {
          return t.palette.other.twitter;
        },
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      children: /*#__PURE__*/_jsx(TwitterIcon, {
        sx: function sx(t) {
          return {
            fill: t.palette.common.white,
            height: 28,
            width: 28
          };
        }
      })
    });
  }

  if (__typename === 'Linkedin') return /*#__PURE__*/_jsx(LinkedInIcon, {
    sx: function sx(t) {
      return {
        height: 48,
        width: 48,
        fill: t.palette.other.linkedIn
      };
    }
  });
  if (__typename === 'Apple') return /*#__PURE__*/_jsx(AppleIcon, {
    sx: function sx(t) {
      return {
        height: 48,
        width: 48,
        fill: t.palette.common.black
      };
    }
  });

  if (__typename === 'OAuth2') {
    return /*#__PURE__*/_jsx("img", {
      src: resolveNextViteImage(oauthIcon),
      style: {
        height: '48px',
        width: '48px',
        objectFit: 'contain'
      },
      alt: "Oauth Icon"
    });
  }

  return absurd(__typename);
};

export default ProviderIcon;